<template>
    <div>
        <div class="overlay" @click="closeModal"></div>
        <div class="modal modal--choose-groups">
            <h3>{{$t('choose_groups')}}</h3>

            <button type="button" class="button button--icon button--modal-close" @click="closeModal">
                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="icon icon--close">
                    <path d="M5.35363 0.252926L3.38886 2.21891L1.42288 0.252926C0.654 -0.515949 -0.523644 0.641014 0.25618 1.42084L2.22095 3.38561L0.25618 5.35159C-0.511478 6.11803 0.656433 7.28594 1.42288 6.51829L3.38886 4.55352L5.35363 6.51829C6.12129 7.28594 7.28798 6.11803 6.52154 5.35159L4.55556 3.38561L6.52154 1.42084C7.28798 0.653179 6.12129 -0.514732 5.35363 0.252926Z" fill="#BDBDBD"/>
                </svg>
            </button>

            <div class="inner-block__field">
                <label for="choose-groups">{{ $t('students_groups') }}</label>

                <multiselect
                        id="choose-groups"
                        v-model="value"
                        :options="schoolGroups"
                        :multiple="true"
                        track-by="id"
                        :custom-label="customLabel"
                        :close-on-select="false"
                        :group-select="true"
                        :placeholder="$t('choosen_groups')"
                        searchable
                >
                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }}
                            {{ $t('choosen_groups_options') }}</span>
                    </template>

                </multiselect>
            </div>

            <div class="buttons-container">
                <button class="button button--accent button--modal-action" type="button" @click="attachGroups">{{ $t('choose') }}</button>
                <button class="button button--hollow button--modal-action" type="button" @click="closeModal">{{ $t('cancel') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import Multiselect from 'vue-multiselect'
    import env from '../../../env'

    export default {
        data: () => ({
            env,
            value: null,
        }),
        computed: {
            ...mapGetters([
                'schoolGroups',
                'mainChat'
            ])
        },
        methods: {
            customLabel(schoolGroups) {
                return schoolGroups.name
            },
            select(schoolGroups) {
                schoolGroups.selected = !schoolGroups.selected
            },
            attachGroups() {
                this.$store.commit("SET_FOR_COMPONENT", {page: 'mainChat', field: 'techChatGroups', value: this.value});
                this.closeModal();
            },
            closeModal() {
                this.$store.commit('SET_MODAL_STATE', {modal: 'chooseGroups', prop: 'isActive', value: false});
            },
        },
        created() {
            this.value = this.mainChat.techChatGroups;
        },
        components: {
            Multiselect
        },
    }
</script>

<style scoped lang="sass">
    @import "../../../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"
    @import "../../../../sass/modals"

</style>
